import App_default from "./App.vue.js";
export { App_default as Chat };
